<template>
  <div class="custom-control custom-checkbox">
    <slot />
    <label
      class="custom-control-label"
      :for="target"
    >
      {{ caption }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'RememberMe',
  props: {
    caption: {
      type: String,
      required: true
    },
    target: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>

</style>
